
<div fxLayout="column" *ngFor="let rub of rubrics$ | rubsfilter   ; let first = first; let last = last;"
  [ngStyle]="{'margin-top' : first && rub.id === 'promo' ? '30px' : ''}" [class.none]="rub.id=='all'">

  <div *ngIf="rub.id!=='all'"  id="{{rub.id}}" class="p-4 flex flex-row gap-4" >
    <span class="text-xl font-bold text-gray-700" >{{rub.name | uppercase}}</span>
    <mat-icon *ngIf="rub.id === 'promo'">alarm</mat-icon>
  </div>

  <!-- Grid type -->
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 auto-rows-fr" *ngIf="isDisplaySquare()">

    <app-product-item-list *ngFor="let prod of rub.products" [merchantClient$]="merchantClient$" [prod]="prod"
               displayMode="0"
              (openProdDialEvent)="openProdDial($event, 'add')"></app-product-item-list>
  </div>

  <!-- List Type -->
  <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 auto-rows-fr" *ngIf="isDisplayRectangle()">

    <app-product-item-list *ngFor="let prod of rub.products" [merchantClient$]="merchantClient$" [prod]="prod"
                           displayMode="1"
                           (openProdDialEvent)="openProdDial($event, 'add')"></app-product-item-list>
  </div>

  <!-- button more products -->

  <div class="text-center mt-8" *ngIf="last && more_products_button && !loaderpop">
    <button (click)="Moreproducts(rub)" class="text-gray-700 border border-gray-300 py-2 px-4 rounded-md hover:bg-gray-100 transition-colors duration-200">
      {{"more_product"|translate}}
    </button>
  </div>

</div>

